@if (isLoggedIn) {
  <div>
    <div style="height: 5px; background-color: white;"></div>
    <p-tabView [(activeIndex)]="activeIndex" #tabview>
      <p-tabPanel header="Layer-2 Trace" [selected]="true">
        <layer2-trace></layer2-trace>
      </p-tabPanel>
      @if (canEnableDisablePorts) {
        <p-tabPanel header="Enable/Disable Ports">
          <port-enable-disable></port-enable-disable>
        </p-tabPanel>
      }
      @if (canManagePortPoe) {
        <p-tabPanel header="Manage Port POE">
          <port-poe-status></port-poe-status>
        </p-tabPanel>
      }
      @if (canManagePortAccessVlans) {
        <p-tabPanel header="Manage Port Access VLANs">
          <port-access-vlan></port-access-vlan>
        </p-tabPanel>
      }
      @if (canViewJackLookup) {
        <p-tabPanel header="Jack -> Switch Lookup">
          <jack-to-switch-lookup></jack-to-switch-lookup>
        </p-tabPanel>
      }
      @if (canViewJackLookup) {
        <p-tabPanel header="Switch -> Jack Lookup">
          <switch-to-jack-lookup></switch-to-jack-lookup>
        </p-tabPanel>
      }
      @if (canViewJackLookup) {
        <p-tabPanel header="Room -> Jack Lookup">
          <room-jacks-lookup [ifTableHeightVh]="100" [ifTableHeightPx]="-510" [ifTableMinHeight]="150"></room-jacks-lookup>
        </p-tabPanel>
      }
      <p-tabPanel header="Find Host">
        <find-host></find-host>
      </p-tabPanel>
    </p-tabView>
  </div>
}